(function () {
  function injectSizeLabels() {
    document.querySelectorAll('.select-alphabets .hulk_po_radio').forEach(function (el) {
      if (el.querySelector('.hulk-size-label')) return;
      var val = el.getAttribute('value') || el.getAttribute('data-conditional-value') || '';
      el.style.cssText += 'background-image:none !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;';
      var span = document.createElement('span');
      span.className = 'hulk-size-label';
      span.style.cssText = 'pointer-events:none;font-size:11px;line-height:1;';
      span.textContent = val;
      el.appendChild(span);
    });
  }

  function bindCheckbox() {
    document.querySelectorAll('.hulkapps_check_option').forEach(function (label) {
      var chk = label.querySelector('input[type="checkbox"]');
      var box = label.querySelector('.hulkapps-custom-check');
      if (!chk || !box) return;
      function sync() {
        if (chk.checked) {
          box.classList.add('is-checked');
        } else {
          box.classList.remove('is-checked');
        }
      }
      label.addEventListener('click', function () {
        setTimeout(sync, 10);
      });
      sync();
    });
  }

  function removeErrors() {
    document.querySelectorAll('.hulk_val_err').forEach(function (e) {
      e.remove();
    });
    document.querySelectorAll('[data-hulk-err]').forEach(function (e) {
      e.removeAttribute('data-hulk-err');
      e.removeAttribute('style');
    });
  }

  function flag(opt, msg) {
    opt.setAttribute('data-hulk-err', '1');
    opt.style.cssText = 'border:1.5px solid #cc0000 !important;border-radius:5px;padding:10px';
    var p = document.createElement('p');
    p.className = 'hulk_val_err';
    p.style.cssText = 'color:#cc0000;font-size:1.1rem;text-align:center;margin:6px 0 0;';
    p.textContent = msg;
    opt.appendChild(p);
  }

  function validate() {
    removeErrors();
    var ok = true;
    document.querySelectorAll('.hulkapps_option.required').forEach(function (opt) {
      var hidden = opt.querySelector('input.hulk_swatch_hidden_prop');
      if (hidden && hidden.value.trim() === '') {
        ok = false;
        flag(opt, '⚠ Please select an option.');
      }
      var chk = opt.querySelector('.hulk_po_checkbox');
      if (chk && !chk.checked) {
        ok = false;
        flag(opt, '⚠ Please check this box.');
      }
    });
    return ok;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.hulkapps_option_child, .hulkapps_check_option');
    if (!t) return;
    var opt = t.closest('.hulkapps_option');
    if (!opt) return;
    setTimeout(function () {
      opt.removeAttribute('data-hulk-err');
      opt.removeAttribute('style');
      var err = opt.querySelector('.hulk_val_err');
      if (err) err.remove();
    }, 15);
  });

  var origFetch = window.fetch;
  window.fetch = function (url, opts) {
    if (typeof url === 'string' && url.includes('/cart/add')) {
      if (document.querySelector('.hulkapps_product_options') && !validate()) {
        var first = document.querySelector('[data-hulk-err]');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return Promise.reject(new Error('Please select all required options'));
      }
    }
    return origFetch.apply(this, arguments);
  };

  function bindForms() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener(
        'submit',
        function (e) {
          if (document.querySelector('.hulkapps_product_options') && !validate()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var first = document.querySelector('[data-hulk-err]');
            if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        },
        true
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectSizeLabels();
    bindCheckbox();
    bindForms();
  });
})();
